import {configureStore} from '@reduxjs/toolkit';
import {promiseResolverMiddleware} from '~/common/middleware/promiseResolver';
import {rootReducer} from './reducers';

export const middlewares = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  }).concat(promiseResolverMiddleware);

export function createGalleryStore(initialState) {
  return configureStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: middlewares,
  });
}
